import { markRaw } from 'vue'

import ChartBarIcon from 'vue-material-design-icons/ChartBar.vue'
import ImageMultipleOutlineIcon from 'vue-material-design-icons/ImageMultipleOutline.vue'
import AccountDetailsIcon from 'vue-material-design-icons/AccountDetails.vue'
import UploadMultipleOutlineIcon from 'vue-material-design-icons/UploadMultipleOutline.vue'
import CogIcon from 'vue-material-design-icons/Cog.vue'

/**
 * Media Manager (mmMode) sidebar menu.
 * Simplified 5-item menu for media manager users.
 */
const menuItems = [
	{
		label: 'Dashboard',
		link: '/home',
		icon: markRaw(ChartBarIcon),
	},
	{
		label: 'Media',
		link: '/assets',
		icon: markRaw(ImageMultipleOutlineIcon),
	},
	{
		label: 'Members',
		link: '/members',
		icon: markRaw(AccountDetailsIcon),
	},
	{
		label: 'Upload',
		link: '/upload',
		icon: markRaw(UploadMultipleOutlineIcon),
	},
	{
		label: 'Settings',
		link: '/settings/general',
		icon: markRaw(CogIcon),
	},
]

export default menuItems
